import request from '@/core/request'
import { ResponseData, TextKind } from './type'
import { NobleConfigType } from '@/packages/official/noble/type'
import { MayDayInfoType, MayDayGiftInfoType } from '@/packages/activity/may_day/type'
import { ProductType, RoomInfoType } from '@/packages/type'
import {
  ConstellationInfoType,
  RankListType,
  StarSignRewardType,
  StarSignSettingType,
  TaskType,
} from '@/packages/activity/constellation/type'
import { CpInfoType } from '@/packages/official/cp/type'
import { BlessType, blindboxConfigType, ConfessionType, GiftType, RankType, SweetKind } from '@/packages/activity/520/type'
import { TeamsInfo, GuardRankItem, SweetBattleCallInfo } from '@/packages/activity/20250702/types/types'
export async function getRandomRoomId(): Promise<ResponseData<RoomInfoType>> {
  return await request.get('/api/audioroom/v1/audioroom/random/choice')
}

export async function getNodelCenterInfo(): Promise<ResponseData<NobleConfigType>> {
  return await request.get('/api/noble/v1/center')
}

export async function getProducts(params: { t: number }): Promise<ResponseData<{ products: ProductType[] }>> {
  return await request.get('/api/dressup/v1/prop_mall/products', params)
}

export async function buyProduct(data: { sku_id: number; count?: number }): Promise<ResponseData<{}>> {
  return await request.post('/api/dressup/v1/prop_mall/buy', data)
}

export async function getMaydayInfo(): Promise<ResponseData<MayDayInfoType>> {
  return await request.get('/api/activities/globaltour/v1/process')
}

export async function getMaydayMarkInfo(params: { gift_id: number }): Promise<ResponseData<MayDayGiftInfoType>> {
  return await request.get('/api/activities/globaltour/v1/top_list', params)
}

export async function getConstellationInfo(): Promise<ResponseData<ConstellationInfoType>> {
  return await request.get('/api/activities/starsign/v1/constellation/index')
}

export async function getConstellationTasks(): Promise<ResponseData<TaskType>> {
  return await request.get('/api/activities/starsign/v1/constellation/tasks/info')
}

export async function getConstellationReward(): Promise<ResponseData<{}>> {
  return await request.post('/api/activities/starsign/v1/constellation/tasks/finish')
}

export async function signConstellationTask(): Promise<ResponseData<{ tasks: TaskType[] }>> {
  return await request.post('/api/activities/starsign/v1/constellation/tasks/checkin')
}

export async function doConstellationTask(data: { task_id: number }): Promise<ResponseData<{ jump_link: string }>> {
  return await request.post('/api/activities/starsign/v1/constellation/tasks/to_finish', data)
}

export async function getConstellationRank(): Promise<
  ResponseData<{ guardian_billboard_list: RankListType[]; spokesman_billboard_list: RankListType[] }>
> {
  return await request.get('/api/activities/starsign/v1/constellation/billboard')
}

export async function getConstellationStarSignSettings(): Promise<ResponseData<StarSignSettingType>> {
  return await request.get('/api/activities/starsign/v1/settings')
}

export async function doConstellationStarSignTask(data: {
  round: number
}): Promise<ResponseData<{ my_balance: number; prize_list: StarSignRewardType[] }>> {
  return await request.post('/api/activities/starsign/v1/draw', data)
}

export async function getCpPublicBillboard(): Promise<ResponseData<{ cp_infos: CpInfoType[] }>> {
  return await request.get('/api/friendship/v2/cp/public/billboard')
}

export async function get520SweetBillboard(params: {
  billboard_type: SweetKind
}): Promise<ResponseData<{ billboard_list: RankType[]; user_rank: RankType }>> {
  return await request.get('/api/activities/wedding520/v1/sweet_billboard', params)
}

export async function get520BlindboxConfig(): Promise<ResponseData<blindboxConfigType>> {
  return await request.get('/api/activities/wedding520/v1/blindbox/config')
}

export async function postBuyPiece(data: {
  count: number
}): Promise<ResponseData<{ gold_coin_balance: number; ticket_cnt: number }>> {
  return await request.post('/api/activities/wedding520/v1/blindbox/buy_piece', data)
}

export async function postDrawAward(data: { count: number }): Promise<ResponseData<blindboxConfigType>> {
  return await request.post('/api/activities/wedding520/v1/blindbox/draw', data)
}

export async function get520Confession(params: { type: number; last_id?: number }): Promise<ResponseData<ConfessionType>> {
  return await request.get('/api/activities/wedding520/v1/wall', params)
}

export async function getCurrentRoom(params: { user_id: number }): Promise<ResponseData<RoomInfoType>> {
  return await request.get('/api/audioroom/v1/audioroom/query', params)
}

export async function getBlessRecord(params: { id: number }): Promise<ResponseData<{ bless_records: BlessType[] }>> {
  return await request.get('/api/activities/wedding520/v1/wall/bless_records', params)
}

export async function getRandomText(params: { text_type: TextKind }): Promise<ResponseData<{ content: string }>> {
  return await request.get('/api/common/v1/text/random', params)
}

export async function postConfession(data: { uid: number; content: string }): Promise<ResponseData<{}>> {
  return await request.post('/api/activities/wedding520/v1/wall/confession', data)
}

export async function postBless(data: { id: number }): Promise<ResponseData<{}>> {
  return await request.post('/api/activities/wedding520/v1/wall/bless', data)
}

export async function getWeddingProcess(): Promise<
  ResponseData<{ confession_val: number; gift_list: { gift: GiftType; count: number }[] }>
> {
  return await request.get('/api/activities/wedding520/v1/wall/confession_process')
}

export async function getTopMessage(): Promise<{ data: string[] }> {
  return await request.get('/api/activities/wedding520/v1/top_messages')
}

export async function getChildrenDayConfig(): Promise<
  ResponseData<{
    top_messages: string[]
    progress: number
    total: number
    collected: number
    prop_details: { gift_id: number; count: number }[]
  }>
> {
  return await request.get('/api/activities/june2025/v1/gachapon/progress')
}

export async function getChildrenDayProcess(): Promise<
  ResponseData<{ my_score: number; stages: { completed: boolean; stage: number; progress: number; total: number }[] }>
> {
  return await request.get('/api/activities/june2025/v1/guardian/progress')
}

export async function getChildrenDayRank(params: {
  type: number
}): Promise<ResponseData<{ billboard: RankType[]; user_rank: RankType }>> {
  return await request.get('/api/activities/june2025/v1/ranking/info', params)
}

export async function getAct20250702ScheduleProcess(): Promise<ResponseData<{ currtent: number }>> {
  const mockScheduleProcessData = {
    currtent: 1,
  }
  await new Promise(resolve => setTimeout(resolve, 500))
  return {
    status: 0,
    data: mockScheduleProcessData,
    msg: 'success',
  }
  // return await request.get('/api/activities/june2025/v1/schedule/process')
}

export async function getAct20250702SweetBattleCallInfo(): Promise<ResponseData<SweetBattleCallInfo>> {
  return await request.get('/api/activities/sweet_battle/call/info')
}

export async function Act20250702DailyCheckin(): Promise<ResponseData<{ tickets: number }>> {
  return await request.post('/api/activities/sweet_battle/call/task/daily_checkin')
}

export async function getAct20250702GetBagInfo(): Promise<ResponseData<{ ticket_count: number; plus_card_count: number }>> {
  return await request.get('/api/activities/sweet_battle/bag')
}

export async function useAct20250702PlusCard(params: {
  count: number
}): Promise<ResponseData<{ ticket_count: number; plus_card_count: number }>> {
  return await request.post('/api/activities/sweet_battle/plus_card/use', params)
}

export async function getAct20250702ParticipantRank(params: { team_type: number }): Promise<ResponseData<TeamsInfo>> {
  // const mockParticipantData = {
  //   rank_list: [
  //     {
  //       team_id: 1,
  //       team_name: '甜妹',
  //       team_slogan: '为了荣耀而战！！战吧站吧！战吧站吧！战吧...战吧站吧！战吧站吧！战吧...战吧...',
  //       vote_count: 10,
  //       team_avatars: [
  //         {
  //           id: 1,
  //           name: '甜妹',
  //           avatar_url: 'https://media.hifun.chat/mobileclient/android/img_1728899560187',
  //         },
  //       ],
  //     },
  //     {
  //       team_id: 1,
  //       team_name: '甜妹',
  //       team_slogan: '为了荣耀而战！！战吧站吧！战吧站吧！战吧...战吧站吧！战吧站吧！战吧...战吧...',
  //       vote_count: 9,
  //       team_avatars: [
  //         {
  //           id: 1,
  //           name: '甜妹',
  //           avatar_url: 'https://media.hifun.chat/mobileclient/android/img_1728899560187',
  //         },
  //       ],
  //     },
  //     {
  //       team_id: 1,
  //       team_name: '甜妹',
  //       team_slogan: '为了荣耀而战！！战吧站吧！战吧站吧！战吧...战吧站吧！战吧站吧！战吧...战吧...',
  //       vote_count: 0,
  //       team_avatars: [
  //         {
  //           id: 1,
  //           name: '甜妹',
  //           avatar_url: 'https://media.hifun.chat/mobileclient/android/img_1728899560187',
  //         },
  //       ],
  //     },
  //     {
  //       team_id: 1,
  //       team_name: '甜妹',
  //       team_slogan: '为了荣耀而战！！战吧站吧！战吧站吧！战吧...战吧站吧！战吧站吧！战吧...战吧...',
  //       vote_count: 0,
  //       team_avatars: [
  //         {
  //           id: 1,
  //           name: '甜妹',
  //           avatar_url: 'https://media.hifun.chat/mobileclient/android/img_1728899560187',
  //         },
  //       ],
  //     },
  //   ],
  //   ticket_count: 0,
  // }
  // await new Promise(resolve => setTimeout(resolve, 500))
  // return {
  //   status: 0,
  //   data: mockParticipantData,
  //   msg: 'success',
  // }
  return await request.get('/api/activities/sweet_battle/teams', params)
}

export async function getAct20250702GuardRank(params: {
  team_type: number
}): Promise<ResponseData<{ rank_list: GuardRankItem[] }>> {
  // const mockGuardRankData = [
  //   {
  //     user_id: 1,
  //     avatar: 'https://media.hifun.chat/mobileclient/android/img_1728899560187',
  //     nickname: '甜妹',
  //     guardian_value: 100,
  //     guardian_slogan: '为了荣耀而战！！战吧站吧！战吧站吧！战吧...战吧站吧！战吧站吧！战吧...战吧...',
  //   },
  //   {
  //     user_id: 1,
  //     avatar: 'https://media.hifun.chat/mobileclient/android/img_1728899560187',
  //     nickname: '甜妹',
  //     guardian_value: 100,
  //     guardian_slogan: '为了荣耀而战！！战吧站吧！战吧站吧！战吧...战吧站吧！战吧站吧！战吧...战吧...',
  //   },
  //   {
  //     user_id: 1,
  //     avatar: 'https://media.hifun.chat/mobileclient/android/img_1728899560187',
  //     nickname: '甜妹',
  //     guardian_value: 100,
  //     guardian_slogan: '为了荣耀而战！！战吧站吧！战吧站吧！战吧...战吧站吧！战吧站吧！战吧...战吧...',
  //   },
  //   {
  //     user_id: 1,
  //     avatar: 'https://media.hifun.chat/mobileclient/android/img_1728899560187',
  //     nickname: '甜妹',
  //     guardian_value: 100,
  //     guardian_slogan: '为了荣耀而战！！战吧站吧！战吧站吧！战吧...战吧站吧！战吧站吧！战吧...战吧...',
  //   },
  // ]
  // await new Promise(resolve => setTimeout(resolve, 500))
  // return {
  //   status: 0,
  //   data: mockGuardRankData,
  //   msg: 'success',
  // }
  return await request.get('/api/activities/sweet_battle/guardian/star', params)
}

export async function getAct20250702Vote(data: {
  team_type: number
  team_id: number
  vote_count: number
}): Promise<ResponseData<{ actual_vote_count: number }>> {
  return await request.post('/api/activities/sweet_battle/vote', data)
}

export async function getPhoneVerifyCode(data: {
  phone_area_code: string
  phone_number: string
  scene: 2
  version: '9.0.0'
}): Promise<ResponseData<null>> {
  return await request.post('/api/ucuser/v1/phoneverifycode/send', data)
}

export async function postPhoneVerifyCode(data: {
  phone_area_code: string
  user_token: string
  verify_code: string
  channel_t: number
  version: '9.0.0'
}): Promise<ResponseData<{ access_token: string; public_id: string; rc_token: string; userid: number }>> {
  return await request.post('/api/ucuser/v1/broadcaster/login', data)
}

export async function getAppLoginLink(): Promise<ResponseData<{ url: string }>> {
  return await request.get('/api/ucuser/v1/auth_code')
}

export enum AuthStatus {
  Pending = 0,
  Success = 1,
  Failed = 2,
}

export async function getAppLoginStatus(params: { code: string }): Promise<ResponseData<{ auth_status: AuthStatus }>> {
  return await request.get('/api/ucuser/v1/auth_code/status', params)
}

export async function postAppLogin(data: {
  code: string
}): Promise<ResponseData<{ access_token: string; public_id: string; rc_token: string; userid: number }>> {
  return await request.post('/api/ucuser/v1/auth_code/login', data)
}

export async function getWithdrawSignUrl(): Promise<
  ResponseData<{
    sign_url: string
    sign_title: string
    real_name_info: {
      real_name: string
      id_card_no: string
      phone: string
    }
  }>
> {
  return await request.get('/broadcaster/v1/withdraw/sign_url')
}

export async function postWithdrawSign(data: {
  real_name: string
  id_card_no: string
  phone: string
}): Promise<ResponseData<{ sign_result: boolean }>> {
  return await request.post('/broadcaster/v1/withdraw/sign', data)
}
export async function getRealUserAuthUrl(): Promise<ResponseData<{ face_auth_url: string }>> {
  return await request.post('/broadcaster/v1/withdraw/face_auth')
}
